import { render, staticRenderFns } from "./TransferenciaItems.vue?vue&type=template&id=14e3f518&scoped=true&"
import script from "./TransferenciaItems.vue?vue&type=script&lang=js&"
export * from "./TransferenciaItems.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciaItems.vue?vue&type=style&index=0&id=14e3f518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e3f518",
  null
  
)

export default component.exports